var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"buy-now",attrs:{"href":"https://www.saxo.com/dk/tryk-og-glad-godnatlaesning_katrine-birklena-adalberthanne-marie-bersaa_indbundet_9788763859820","target":"_blank"}},[_c('btn',[_vm._v("Køb bogen her")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }